import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "q-pa-lg" }
const _hoisted_2 = { class: "text-body1 text-weight-bold q-mb-sm" }
const _hoisted_3 = { class: "text-grey-7 text-body1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-body1" }
const _hoisted_6 = { class: "flex items-center q-mt-sm q-gutter-y-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_cancel_request_btn = _resolveComponent("cancel-request-btn")!
  const _component_toggle_reminders_btn = _resolveComponent("toggle-reminders-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" New Posts Requested - "),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_humanize_time, {
          time: _ctx.request.createdAt
        }, null, 8, ["time"]),
        (_ctx.request.creator)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " by " + _toDisplayString(_ctx.request.creator.firstName) + " " + _toDisplayString(_ctx.request.creator.lastName), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, " The client has been requested to import their " + _toDisplayString(_ctx.platform) + " posts into Private Footprint. ", 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_cancel_request_btn, {
        request: _ctx.request,
        class: "on-left",
        onCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('canceled')))
      }, null, 8, ["request"]),
      _createVNode(_component_toggle_reminders_btn, {
        request: _ctx.request,
        "onUpdate:request": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:request', $event)))
      }, null, 8, ["request"])
    ])
  ]))
}